import { JobStatusSchema, JobStatusType } from "../types";

export const isJobProcessing = (status: JobStatusType): boolean =>
  status === JobStatusSchema.enum.STANDBY || status === JobStatusSchema.enum.PROCESSING;
